<template>
  <div>
    <h2>リストを保存</h2>
    <div class="inputs p-fluid">
      <div class="title">
        <input v-model="title" class="titleInput" placeholder="リスト名" />
      </div>
      <div class="p-fluid tags">
        <SetTags ref="tag" class="tagComponent" />
      </div>
    </div>
    <Button @click="save" label="保存" />
    <template v-for="id in store.state.list.ids" v-bind:key="id">
      <SongCard :songId="id" />
    </template>
    <router-link :to="{ name: 'Home' }">
      <ListButton icon="search" />
    </router-link>
    <div v-if="showDialog" class="bg"></div>
    <div v-if="showDialog" class="pop">
      <h2>リストを保存しました</h2>
      <router-link :to="{ name: 'Home' }">
        <p class="ok">OK</p>
      </router-link>
      <a :href="shareUrl" class="twitter flex" target="_blank"
        ><i class="pi pi-twitter">Tweet</i></a
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
import SongCard from "@/components/SongCard.vue";
import ListButton from "@/components/ListButton.vue";
import SetTags from "@/components/SetTags.vue";
import Button from "primevue/button";
import firebase from "../firebase/firebase";
import { v4 as uuidv4 } from "uuid";

export default defineComponent({
  name: "SaveList",
  components: { SongCard, ListButton, SetTags, Button },
  setup() {
    const store = useStore();
    const uuid = uuidv4();
    return {
      store,
      title: "",
      uuid,
      showDialog: ref(false),
    };
  },
  computed: {
    text() {
      return "プレイリスト「" + this.title + "」を作成";
    },
    url() {
      return "https://outa-tube.web.app/list/" + this.uuid;
    },
    shareUrl() {
      return "http://twitter.com/share?url=" + this.url + "&text=" + this.text;
    },
  },
  methods: {
    save() {
      const db = firebase.firestore();
      const user = firebase.auth().currentUser;
      let uid = user.uid;
      if (uid == null) uid = "unknown";
      db.collection("list")
        .doc(this.uuid)
        .set({
          title: this.title,
          songs: this.store.state.list.ids,
          tag: this.$refs.tag.queries,
          authorId: uid,
        })
        .then(() => {
          this.showDialog = true;
          console.log("add succeed");
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
});
</script>

<style scoped>
.title {
  width: 90%;
  max-width: 500px;
  margin: 0 auto;
}
.tags {
  width: 90%;
  max-width: 500px;
  margin: 0 auto;
}
.titleInput {
  padding: 10px;
  font-size: 12pt;
  width: 100%;
}
.tagComponent {
  margin-left: -16px;
  margin-right: -16px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.bg {
  position: fixed;
  z-index: 2;
  right: 0%;
  left: 0%;
  top: 0%;
  bottom: 0%;
  background-color: black;
  opacity: 30%;
}
.pop {
  position: fixed;
  margin: auto;
  right: 10%;
  left: 10%;
  top: 10%;
  bottom: 10%;
  max-height: 300px;
  max-width: 400px;
  background-color: white;
  z-index: 10;
  border-radius: 10px;
  padding-top: 10px;
  color: rgb(31, 31, 31);
}
.twitter {
  color: white;
  background-color: #1da1f2;
  padding: 7px;
  border-radius: 4px;
  vertical-align: center;
}
.ok {
  width: 100px;
  padding: 7px;
  border-radius: 4px;
  margin: 50px auto;
  font-size: 14pt;
  background-color: dimgray;
  color: white;
}
</style>
